export enum ErrorMessage {
  InvalidCard = 'invalid card',
  MissingAppInstanceParam = 'missing app instance param',
  InvalidParams = 'invalid params',
  UnavailableBeforeTokenize = 'public card data is available only after tokenize (Square)',
  UnavailableForProvider = 'this operation is unavailable for this payment provider',
  UnavailableOperation = 'this operation is unavailable for current conditions',
}
